import {URLS} from "../constants";
import BaseForm from "./baseform";

export default class OrderForm extends BaseForm {
	defaultOptions() {
		return {
			ajaxUrl: URLS.ORDER,
			container: ""
		}
	}

	getLoadComponentParams() {
		return {
			personTypeId: this.getCurrentPersonType(),
			phone: this.getCurrentPhone(),
		};
	}

	getCurrentPersonType() {
		return $("[name=PERSON_TYPE]").val();
	}

	getCurrentPhone() {
		return this.options && this.options.hasOwnProperty('phoneSelector') && $(this.options.phoneSelector).length > 0
			?  $(this.options.phoneSelector).val() : "";
	}
}
